import { useMemo } from 'react';

import {
  ILockInfo,
  LockContext,
  useLock,
} from '@work4all/components/lib/hooks';

interface LockOverrideProps {
  forceLock?: boolean;
  lockReason?: string;
  children?: React.ReactNode;
}

/**
 * Allows you to override the LockContext to force all input into a disabled
 * state.
 */
export function LockOverride({
  forceLock = false,
  lockReason,
  children,
}: LockOverrideProps) {
  const ctx = useLock();

  const { locked: originalLocked, loading, lock, unlock, user } = ctx;

  const locked = forceLock || originalLocked;

  const override = useMemo<ILockInfo>(() => {
    return { locked, loading, lock, unlock, user, lockReason };
  }, [locked, loading, lock, unlock, user, lockReason]);

  return (
    <LockContext.Provider value={override}>{children}</LockContext.Provider>
  );
}
